// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'//引入路由文件
import $ from 'jquery'
import ElementUI from 'element-ui'
import '../static/css/commonModel.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/main.css'
import '@/assets/css/adminComm.less'
import '../static/UEditor/themes/default/css/umeditor.min.css'
import '../static/UEditor/dialogs/image/image.css'
import Axios from 'axios'
import BaiduMap from 'vue-baidu-map'//百度地图
import echarts from 'echarts' //引入echarts
Vue.use(ElementUI);
Vue.config.productionTip = false

import '../static/js/jquery-2.0.0.min.js'
import '../static/js/area.js'
import '../static/js/OstPaths.js'
import '../static/UEditor/umeditor.config.js'
import '../static/UEditor/umeditor.min.js'
import '../static/UEditor/lang/zh-cn/zh-cn.js'
import '../static/js/syncLock.js'
import '../static/js/select2.min.js'
import '../static/js/DataDict.js'
import '../static/js/SubAreas.js'
import '../static/js/DataStore.min.js'
import '../static/js/AreaLinkage.js'
import '../static/js/ajaxFileDownloader.js'
import {getCookie} from '../static/js/cookie.js'
import {setCookie} from '../static/js/cookie.js'
import {formatFn} from '../static/js/date.js'
import * as tool from '@/assets/js/tool.js'
import * as cookies from '../static/js/cookie.js' 
Vue.use(BaiduMap, {
  ak: 'qvEBjYRcHmpZCDXR849MnC73QGstenOE'
})
import VideoPlayer from 'vue-video-player'
import 'videojs-contrib-hls'
import md5 from 'js-md5';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.prototype.getCookie = getCookie;
Vue.prototype.setCookie = setCookie;
Vue.prototype.$echarts = echarts //引入组件
Vue.prototype.formatFn = formatFn;

Vue.prototype.tool = tool;
Vue.prototype.cookies = cookies;
Vue.prototype.Axios = Axios;
Vue.prototype.Axios.defaults.withCredentials = true;
Vue.prototype.$md5 = md5;

Vue.prototype.Axios.defaults.headers = {
  'Content-Type': 'application/json',
};
Vue.prototype.openLoading = function() {
  const loading = this.$loading({
    lock: true,
    text: '正在加载...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.3)',
    target: '.sub-main',
    body: true,
    customClass: 'mask'
  })
  return loading;
}
function formatDict(type,val) {//数据字典过滤器
  var val = $(window).DataStore().getDictLabel(type,val);
  return val;
};
//配置高德秘钥
window._AMapSecurityConfig = {
  securityJsCode:'b45032015936e65ac00e672091e043d3',
}
//数据字典过滤器
Vue.filter('formatDict',formatDict);
Vue.filter('formatDate',tool.formatDate);
Vue.filter('formatFn',formatFn);
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods:{
    // urljudge:function(){
    //   if(getCookie('userInfo-admin')) {//添加公用 Authorization
    //     Axios.defaults.headers.Authorization = JSON.parse(getCookie('userInfo-admin')).tokenType+ ' ' + JSON.parse(getCookie('userInfo-admin')).accessToken;
    //     this.userType = JSON.parse(getCookie('userInfo-admin')).userType
    //   }else{
    //     this.$router.push("login")
    //   }
    // }
  },
  // watch:{
  //   '$route':function(){
  //      this.urljudge();  
  //      Axios.interceptors.response.use(function(res){
  //       //在这里对返回的数据进行处理
  //       var data = res.data;
  //       return res;
  //     },function(err){
  //       //Do something with response error
  //       var isErrInfo = arguments[0].response.data.error_description.indexOf('Access token expired');//权限是否过期
  //       if(isErrInfo>=0) {
  //         setCookie('userInfo-admin','');
  //         this.$router.push('login');
  //       }
  //       return Promise.reject(err);
  //     });
  //   return false;
  //   }
  // },
  
})



// WEBPACK FOOTER //
// ./src/main.js